import {Component} from 'react';
import {Container, Icon, Popup} from 'semantic-ui-react';

export default class SoiReportTypeTip extends Component {
  render() {
    return (
      <Popup on="click" wide
             position="right center"
             trigger={<Icon name="help circle outline" link/>}>
        <Container fluid>
          <p>
            The Indicative Selling Price may be expressed as:
          </p>
          <ul>
            <li>a single price (eg $500,000), or</li>
            <li>a price range of up to 10 per cent (eg $500,000 - $550,000).</li>
          </ul>
          <p>
            It must not be less than:
          </p>
          <ul>
            <li>your estimated selling price,</li>
            <li>the seller's asking price, or</li>
            <li>a price in a written offer that has already been rejected by the seller.</li>
          </ul>
        </Container>
      </Popup>
    );
  }
}